import type { SelectionPayload } from "../lib/office";

export function SelectionChip({
  selection,
  enabled,
  onToggle,
}: {
  selection: SelectionPayload | null;
  enabled: boolean;
  onToggle: () => void;
}) {
  if (!selection || selection.slides.length === 0) return null;
  const nums = selection.slides.map((s) => s.slide).filter((n) => n > 0);
  const label =
    `Dia ${nums.join(", ")}` +
    (selection.shapes.length ? ` · ${selection.shapes.length} shape${selection.shapes.length > 1 ? "s" : ""}` : "");

  return (
    <button
      type="button"
      onClick={onToggle}
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs ${
        enabled
          ? "border-accent bg-accent/15 text-fg"
          : "border-border text-muted-fg"
      }`}
      title={enabled ? "Selectie wordt meegestuurd" : "Selectie wordt niet meegestuurd"}
    >
      <span>{enabled ? "📎" : "○"}</span>
      <span className="font-mono">{label}</span>
    </button>
  );
}
